export function addCurrent(permission) {
    return {
        type: 'ADD_CURRENT_PERMISSION',
        permission,
    }
}
